import {Response} from '@angular/http';

export class ResponseWrapper<T> {
  constructor(private _response: Response, private _data: T = null) {
  }

  get response(): Response {
    return this._response;
  }

  get data(): T {
    return this._data;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/response-wrapper.ts